import * as INSTITUTIONS from '../../actionTypes/Institutions/Institutions'
import Constants from '../../Constants'
import Api from '../../Api'

const api = new Api();

function getInstitutionsSuccess (institutions) {
  return {
    type: INSTITUTIONS.INSTITUTIONS_LIST,
    institutions: institutions
  }
}

export const fetchGlobalInstitutions = () => {
  return async (dispatch) => {
    try {
      const resp = await api.getData(Constants.apiUrls.institutions);
      dispatch(getInstitutionsSuccess(resp));
    } catch (err) {
      console.error(err);
    }
  }
}
